<template>
  <div class="contest-profile-widget">
    <template v-if="isAuthenticated">
      <UserStatus v-if="status" />
      <dropdown-menu>
        <template v-slot:activator>
          <ContestUserAuthInfo />
        </template>

        <div class="dropdown-list">
          <AppBtn block @click="openProfile">
            Профиль
          </AppBtn>
          <AppBtn block @click="logout">
            Выход
          </AppBtn>
        </div>
      </dropdown-menu>
    </template>
    <div class="px-4 spacer" v-else>
      <AppBtn block round icon color="orange-grad" @click="login">
        <span>Войти</span>
      </AppBtn>
    </div>
  </div>
</template>

<script>
import UserStatus from "@/components/user/UserStatus";
import ContestUserAuthInfo from "./ContestUserAuthInfo";
import { openModal as showSigninModal } from "./ContestAuth";

import { mapGetters, mapActions } from "vuex";

export default {
  components: { UserStatus, ContestUserAuthInfo },
  props: {
    status: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapGetters("contest", ["isAuthenticated"])
  },

  methods: {
    ...mapActions("contest", ["logout", "openProfile"]),
    login() {
      showSigninModal();
    }
  }
};
</script>

<style lang="scss">
.contest-profile-widget {
  display: inline-flex;
  align-items: center;

  .menubar & {
    display: flex;
  }
}
</style>
